<template>
  <div
    ref="containerStatus"
    :id="'container-status-' + container_info.id"
    class="vx-card vs-con-loading__container"
    :style="{ 'box-shadow': 'none', 'border': '1px solid ' + AISEA_COLOR.LIGHT_GRAY }"
    :class="[ 
      ( power === 'OFF' ? 'power-off' : size === 'large' ?  'cursor' : null ),
      ( size === 'small' ?  'container-card-small' : size === 'large' ? 'container-card-large' : 'container-card-medium'),
    ]"

    @click="editDialog()"
  >

    <container-status-color-icon
      :status="channel_status"
      :name="container_info.name"
      :size="size"
    />
    <template v-if="size === 'large'">

      <div class="container-info-line">
        <span class="aisea-text-14-400-black">コンテナ番号：</span>
        <span class="aisea-text-14-700-white container-serial-number">
          {{ container_info.appendix && container_info.appendix.serial_number ? container_info.appendix.serial_number : "" }}
        </span>
      </div>
      <div class="container-info-line aisea-text-14-400-black">
        積荷：{{ container_info.appendix && container_info.appendix.cargo ? container_info.appendix.cargo : "-" }}
      </div>
      <div class="container-info-line aisea-text-14-400-black">
        種類：{{ container_info.appendix && container_info.appendix.type ? container_info.appendix.type : "-"  }}
      </div>
      <div class="container-info-line aisea-text-14-400-black">
        設定温度：{{ container_info.appendix && container_info.appendix.preset_temperature ? container_info.appendix.preset_temperature : "-" }}
      </div>
      <div class="container-info-line aisea-text-14-400-black">
        顧客名： {{ 
          container_info.appendix && container_info.appendix.customer && container_info.appendix.customer.name
            ? container_info.appendix.customer.name  : "-"
        }}
      </div>
      <div class="container-info-line aisea-text-14-400-black">
        担当者名：{{ container_info.appendix && container_info.appendix.person_in_charge ? container_info.appendix.person_in_charge : "-" }}
      </div>
      <div class="container-info-line aisea-text-14-400-black">
        電話番号：{{ container_info.appendix && container_info.appendix.tel ? container_info.appendix.tel  : "-" }}
      </div>
      <container-status-detail-form
        ref="containerStatusDetailForm"
        :customers="customers"
        @refresh="refresh"
      />
    </template>
    <template v-else-if="size !== 'small'">
      <div class="aisea-text-14-400-black customer-name">
        {{ 
          container_info.appendix && container_info.appendix.customer && container_info.appendix.customer.name
            ? container_info.appendix.customer.name  : "-"
        }}
      </div>
    </template>
  </div>
</template>

<script>
import ContainerStatusColorIcon from "./ContainerStatusColorIcon";
import ContainerStatusDetailForm from "./ContainerStatusDetailForm";
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("ecoShip");

export default {
  components: { ContainerStatusColorIcon, ContainerStatusDetailForm },
  mixins: [ColorMixin],
  props: {
    container_info: { type: Object },
    enterprise_vessel_id: { type: String },
    customers: { type: Array },
    size: { type: String },
  },
  data() {
    return {
      channel_status: "",
      power: "OFF",
    };
  },
  watch: {
    container_info() {
      this.setStatus();
    },
    hanasysExpertLastUpdatedAt() {
      this.setStatus();
    }
  },
  computed: {
   ...mapState({
      // hanasysExpert: state => state.hanasysExpert,
      hanasysExpertLastUpdatedAt: state => state.hanasysExpertLastUpdatedAt,
    }),
  },
  methods: {
    ...mapActions(["getStatusFromFirestore"]),
    editDialog() {
      // if( this.power === 'OFF'){
      //   return;
      // }
      if ( this.size !== 'large' ) {
        return;
      }

      this.$refs.containerStatusDetailForm.openEditDialog(
        this.enterprise_vessel_id,
        this.container_info
      );
    },
    refresh() {
      this.$vs.loading({ container: this.$refs.containerStatus });
      this.$emit("refresh");
      setTimeout( ()=> {
        this.$vs.loading.close(this.$refs.containerStatus);
      }, 20000); // 最長20秒. 安全装置.
    },
    async setStatus() {
      const status = await this.getStatusFromFirestore({
                        channel_id: this.container_info.channel_id
                      });

      this.channel_status = status.channel_status;
      this.power          = status.power;
      this.$vs.loading.close(this.$refs.containerStatus);
    },
  },
  created() {
    this.setStatus();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.container-card-small {
  margin: 0.5rem;
  border-radius: 20px;
}
.container-card-medium {
  margin: 4px;
  padding: 4px 4px;
}
.container-card-large {
  margin: 5px;
  padding: 8px;
  min-height: 21rem;
}
.cursor {
  cursor: pointer;
}
.container-serial-number {
  background-color: $aisea-black;
}
.power-off {
  background-color: $aisea-light-gray;
}
.root-power-off {
  background-color: rgba($aisea-gray, 0.55);
}
.customer-name {
  margin: 0.3rem 0.4rem;
  width: calc(100% - 1rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.container-info-line {
  margin: 0.4rem
}
</style>